import React from "react";
import { Link } from "react-router-dom";
import ReactGA from "react-ga";
import ReactMarkdown from "react-markdown";
import axios from "axios";
import { MARKDOWN_BASE_URL } from "constants/urls";

import "./Home.scss";

function Home() {
  const [hometop, setHometop] = React.useState("");
  const [homebottom, setHomebottom] = React.useState("");

  React.useEffect(() => {
    const path = "/";
    const homeTopURL = `${MARKDOWN_BASE_URL}/home/home-top.md`;
    const homeBottomURL = `${MARKDOWN_BASE_URL}/home/home-bottom.md`;
    // Getting Top Home URL
    axios
      .get(homeTopURL)
      .then(function (response) {
        setHometop(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
    // Getting Bottom Home URl
    axios
      .get(homeBottomURL)
      .then(function (response) {
        setHomebottom(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
    ReactGA.set({ page: path });
    ReactGA.pageview(path);
  }, []);

  return (
    <div className="Home">
      <img className="Home-image" src="./hands.png" alt="Multi-colored hands" />
      <div className="Home-content">
        <h1 className="Home-header">Welcome!</h1>
        <ReactMarkdown>{hometop}</ReactMarkdown>
        <Link to="/search" className="Home-button btn btn-primary">
          Enter Here!
        </Link>
        <div className="Home-thanks">
          <ReactMarkdown>{homebottom}</ReactMarkdown>
        </div>
      </div>
    </div>
  );
}

export default Home;
